"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogin = void 0;
// Custom Hooks
var react_1 = require("react");
var login_1 = require("@domain/login");
var SHOW_ALERT_REFERRER = "/password/reset/";
var useLogin = function () {
    var _a = (0, react_1.useState)(), csrfToken = _a[0], setCsrfToken = _a[1];
    var _b = (0, react_1.useState)(), resetToken = _b[0], setResetToken = _b[1];
    var _c = (0, react_1.useState)(), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = (0, react_1.useState)(false), isShowCompleteNotice = _d[0], setIsShowCompleteNotice = _d[1];
    var error = (0, login_1.getError)();
    var isDisabled = function (isValid, isLoading, errors) {
        return !isValid || Object.keys(errors).length > 0 || isLoading;
    };
    var updateShowCompleteNotice = function () {
        var referrer = window.document.referrer;
        if (referrer.includes(SHOW_ALERT_REFERRER)) {
            setIsShowCompleteNotice(true);
        }
    };
    var updateCsrfToken = function () {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- 暫定対応
        var csrfTokenMeta = document.head.querySelector('meta[name="csrf-token"]');
        if (csrfTokenMeta) {
            var csrfToken_1 = csrfTokenMeta.content;
            setCsrfToken(csrfToken_1);
        }
    };
    var updateResetToken = function () {
        var resetToken = (0, login_1.getResetToken)();
        setResetToken(resetToken);
    };
    var updateErrorMessage = function () {
        var errorMessage = (0, login_1.getErrorMessage)();
        setErrorMessage(errorMessage);
    };
    var updateInitializeUsername = function () {
        var referrer = window.document.referrer;
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain -- 暫定対応
        if (referrer && referrer.includes("?email=")) {
            var param = referrer.slice(referrer.indexOf("?email=") + 7);
            return decodeURIComponent(param);
        }
        return "";
    };
    return {
        error: error,
        isDisabled: isDisabled,
        csrfToken: csrfToken,
        updateCsrfToken: updateCsrfToken,
        isShowCompleteNotice: isShowCompleteNotice,
        updateShowCompleteNotice: updateShowCompleteNotice,
        updateInitializeUsername: updateInitializeUsername,
        updateResetToken: updateResetToken,
        resetToken: resetToken,
        updateErrorMessage: updateErrorMessage,
        errorMessage: errorMessage,
    };
};
exports.useLogin = useLogin;
